export const UPDATE_SERVER_SETTINGS_FAILURE = 'UPDATE_SERVER_SETTINGS_FAILURE';

export const updateServerSettingsFailure = error => ({
    type: UPDATE_SERVER_SETTINGS_FAILURE,
    payload: error,
    error: true,
});
